var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoTestopsMedium(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "35px",
    viewBox: "0 0 35 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Get-Started",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3-Invite-users-to-your-organization",
    transform: "translate(-653.000000, -477.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo-testops",
    transform: "translate(653.000000, 477.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-1",
    fill: "#57CFFF",
    points: "0 35 17.4816749 35 14.3714453 32.5175667 34.2737617 0 0 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-2",
    fill: "#4D94FF",
    points: "34.2737617 35 15.6908973 35 8.56844043 23.2356187 20.2103579 11.875"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(7.956409, 8.750000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.901896001,-2.30263158e-05 L10.6358698,-2.30263158e-05 C12.3599302,-2.30263158e-05 14.0136392,0.699516447 15.2328381,1.94431908 C16.4518115,3.18958224 17.1368358,4.87810197 17.1368358,6.63869408 L17.1368358,16.5789243 C17.1368358,17.0875757 16.7329916,17.499977 16.2348947,17.499977 L6.50092085,17.499977 C4.77686044,17.499977 3.12337692,16.8004375 1.90417805,15.5556349 C0.684979167,14.310602 -4.50970549e-05,12.6220822 -4.50970549e-05,10.8612599 L-4.50970549e-05,0.921029605 C-4.50970549e-05,0.412378289 0.403799029,-2.30263158e-05 0.901896001,-2.30263158e-05",
    id: "Fill-3",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#4E95FF",
    points: "4.05868984 3.22366118 13.0264647 3.22366118 13.0264647 5.90783882 10.0115011 5.90783882 10.0115011 14.2762928 7.07387893 14.2762928 7.07387893 5.90783882 4.05868984 5.90783882"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTestopsMedium);
export default __webpack_public_path__ + "static/media/logo_testops_medium.46edfabeb562070101d43c8118c10bb5.svg";
export { ForwardRef as ReactComponent };